if ('IntersectionObserver' in window) {

    let options = {
        root: null, // relative to document viewport
        rootMargin: '0px 0px 400px', // margin around root. Values are similar to css property. Unitless values not allowed
        threshold: 0 // visible amount of item shown in relation to root
    };

    let onIntersectionChange = function (changes, observer) {
        changes.forEach(change => {
            if (change.intersectionRatio > 0) {
                loadTarget(change.target);
            }
        });
    };

    let observer = new IntersectionObserver(onIntersectionChange, options);

    function setup() {
        let images = document.querySelectorAll('img.lazy');
        images.forEach(img => observer.observe(img));
    }

    setup();

    setTimeout(setup, 1000);
    setTimeout(setup, 3000);
} else {
    let lazyImages = document.getElementsByClassName('lazy');
    for (let i = 0; i < lazyImages.length; i++) {
        let img = lazyImages[i];
        loadTarget(img);
    }
}

export function loadTarget(target) {
    if (target.classList && !target.classList.contains('lazy')) {
        return;
    }

    if (!target.src) {
        target.src = target.getAttribute('data-src');

        if (target.getAttribute('data-srcset')) {
            target.srcset = target.getAttribute('data-srcset');
        }

        target.onload = function () {
            if (!target.classList || !target.classList.contains('alt-image')) {
                target.className += ' show';
            }
        };

        if (target.classList && target.classList.remove) {
            target.classList.remove('lazy');
        }
    } else {
        target.className += ' show';

        if (target.classList && target.classList.remove) {
            target.classList.remove('lazy');
        }
    }
}